export default {
  data() {
    return {
      captchaResponse: "",
      isCaptchaExist: true,
      captchaLocalStorageKey: 'captcha_is_exist',
      isCaptchaTrackExist: true,
      captchaTrackLocalStorageKey: 'track_captcha_is_exist'
    };
  },
  methods: {
    onCaptchaResponse(res) {
      this.captchaResponse = res;
    },
    onCaptchaExpired() {
      this.captchaResponse = "";
    },
    onCaptchaReset() {
      this.captchaResponse = "";
    },
    onCaptchaError() {
      this.captchaResponse = "";
    },
    getCaptchaExistLs() {
      return JSON.parse(localStorage.getItem(this.captchaLocalStorageKey)) ?? true
    },
    setCaptchaExistLs() {
      this.isCaptchaExist = this.getCaptchaExistLs()
      localStorage.setItem(this.captchaLocalStorageKey, this.isCaptchaExist)
    },
    setIsCaptchaExist() {
      this.isCaptchaExist = this.getCaptchaExistLs()
    },
    matchCaptchaExistLs() {
      const isCaptchaExist = this.getCaptchaExistLs()
      return this.isCaptchaExist === isCaptchaExist
    },
    getCaptchaTrackExistLs() {
      return JSON.parse(localStorage.getItem(this.captchaTrackLocalStorageKey)) ?? true
    },
    setCaptchaTrackExistLs() {
      this.isCaptchaTrackExist = this.getCaptchaTrackExistLs()
      localStorage.setItem(this.captchaTrackLocalStorageKey, this.isCaptchaTrackExist)
    },
    setIsCaptchaTrackExist() {
      this.isCaptchaTrackExist = this.getCaptchaTrackExistLs()
    },
  },
};
